export function staffAnalytics(state = [], action) {
  switch (action.type) {
    case "STAFF_ANALYTICS_FETCH_DATA_SUCCESS":
      return action.staffAnalytics;
    default:
      return state;
  }
}
